var _a, _b, _c, _d;
export const getNumberResponse = (value) => isNaN(value) ? 0 : value;
const performance = (typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.performance) !== null && _a !== void 0 ? _a : {} : {});
const navigation = ((_d = (_c = (_b = performance.getEntriesByType) === null || _b === void 0 ? void 0 : _b.call(performance, 'navigation')) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : {});
export const getPagePerformance = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const DOMContentLoadedIn = (_a = navigation.domContentLoadedEventStart) !== null && _a !== void 0 ? _a : 0;
    const DOMContentLoadedScriptsExecution = getNumberResponse(navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart);
    return {
        pageLoadedIn: (_b = navigation.duration) !== null && _b !== void 0 ? _b : 0,
        connectedToHostIn: getNumberResponse(navigation.connectEnd - navigation.connectStart),
        domainLookup: {
            finishedAt: (_c = navigation.domainLookupEnd) !== null && _c !== void 0 ? _c : 0,
            duration: getNumberResponse(navigation.domainLookupEnd - navigation.domainLookupStart),
        },
        documentLoaded: {
            loadedAt: (_d = navigation.responseEnd) !== null && _d !== void 0 ? _d : 0,
            loadingDuration: getNumberResponse(navigation.responseEnd - navigation.requestStart),
        },
        DOMIsInteractiveIn: (_e = navigation.domInteractive) !== null && _e !== void 0 ? _e : 0,
        DOMContentLoadedIn,
        DOMContentLoadedScriptsExecution,
        pageRenderedIn: (_f = navigation.domContentLoadedEventStart) !== null && _f !== void 0 ? _f : 0,
        DOMRenderedIn: (_g = navigation.domComplete) !== null && _g !== void 0 ? _g : 0,
    };
};
//# sourceMappingURL=index.js.map